import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getABNVariant } from '~/src/helpers/abn-tests';
import { getCurrentCityIn } from '~/src/store/selectors/city';

export const useOptimizedToponym = (testName: string): string | undefined => {
    const currentCityName = useSelector(getCurrentCityIn);
    const isOptimizationToponymsInternetEnabled = useMemo(() =>
            getABNVariant(testName) === 'on',
        [testName]);

    return isOptimizationToponymsInternetEnabled ? ` в ${currentCityName}` : undefined;
};

export const useOptimizationToponymForInternetPage = (): string | undefined =>
     useOptimizedToponym('optimization_toponyms_internet');

